import { createReducer, ActionType } from "typesafe-actions";
import * as actions from "./actions";
import { RoutesState } from "./types";
import initialState from "./state";

type Action = ActionType<typeof actions>;

export default createReducer<RoutesState, Action>(initialState)
  .handleAction(actions.showRoutes, (state, action) => {
    const { count } = action.payload;
    const newShownRoutes = state.hiddenRoutes.slice(0, count);
    const hiddenRoutes = state.hiddenRoutes.slice(count);
    const hiddenItemsWidth = state.hiddenItemsWidth.slice(0, -count);

    return {
      ...state,
      ...(newShownRoutes.length > 0 && {
        shownRoutes: [...state.shownRoutes, ...newShownRoutes],
      }),
      hiddenRoutes,
      hiddenItemsWidth,
    };
  })
  .handleAction(actions.hideRoutes, (state, action) => {
    const lastShownRoute = state.shownRoutes[state.shownRoutes.length - 1];
    const shownRoutes = state.shownRoutes.slice(0, -1);

    return {
      ...state,
      shownRoutes,
      ...(lastShownRoute && {
        hiddenRoutes: [lastShownRoute, ...state.hiddenRoutes],
      }),
      ...(action.payload.lastShownRouteWidth >= 0 && {
        hiddenItemsWidth: [
          ...state.hiddenItemsWidth,
          action.payload.lastShownRouteWidth,
        ],
      }),
    };
  })
  .handleAction(actions.switchToOffline, (state, action) => {
    const { newRoutesState } = action.payload;

    return {
      ...newRoutesState,
    };
  });
